/** Whole days from `today` to a subscription's expiry date; negative = already expired. */
export function daysUntil(expire, today = new Date()) {
    const start = new Date(today);
    start.setHours(0, 0, 0, 0);
    const end = new Date(`${expire.slice(0, 10)}T00:00:00`);
    const days = Math.round((end.getTime() - start.getTime()) / 86_400_000);
    return Number.isFinite(days) ? days : null;
}
/** «Подписка до» in the user card: how much is left, in words. */
export function expiryText(expire, today) {
    if (!expire)
        return { text: 'нет подписки', expired: true };
    const days = daysUntil(expire, today);
    if (days === null)
        return { text: expire, expired: false };
    if (days < 0)
        return { text: 'истекла', expired: true };
    if (days === 0)
        return { text: 'истекает сегодня', expired: false };
    return { text: `ещё ${days} дн.`, expired: false };
}
